import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { Modal, Button, Form, CloseButton } from "react-bootstrap";

export function openPasswordModel(next, input = null) {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const root = createRoot(div);
  const close = () => {
    root.unmount();
    div.remove();
    document.body.style.overflow = "auto";
  };
  root.render(
    <PasswordModal
      show={true}
      onPasswordEntered={next}
      close={close}
      inputValue={input}
    />
  );
}

export function PasswordModal(props) {
  const [password, setPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordsMatch(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    props.onPasswordEntered(password, props.inputValue);
    props.close();
  };

  const handleCancel = () => {
    // props.onPasswordEntered(null);
    props.close();
  };

  return (
    <Modal
      show={props.show}
      onHide={handleCancel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Create New Wallet
        </Modal.Title>
        <CloseButton
          onClick={handleCancel}
          style={{ position: "absolute", right: "20px", top: "20px" }}
        />
      </Modal.Header>
      <Modal.Body>
        <p>
          Your wallet is encyrpted with password, please enter your password
        </p>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formPassword">
            <Form.Label>Password:</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={handlePasswordChange}
              isInvalid={!passwordsMatch}
            />
          </Form.Group>
          <br />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          type="submit"
          onClick={handleSubmit}
          disabled={!passwordsMatch}
        >
          Submit
        </Button>
        <Button variant="secondary" onClick={handleCancel}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
